var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54 54"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 87"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 81",
    transform: "translate(.5 -.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "#0a84df",
    "data-name": "Ret\\xE2ngulo 33",
    rx: 27,
    transform: "translate(-.5 .5)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43 13h-6.2a10.3 10.3 0 0 0-10.2 10.3v6.1h-6.2v8.2h6.2V54h8.2V37.6h6.1l2.1-8.2h-8.2v-6.1a2 2 0 0 1 2-2.1H43Z"
  }))));
};
export default SvgFacebook;